import i18next from "i18next";
import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

const apiKey = "r0FQ4AR55T7UoPM4vt-xDA";
const loadPath = `https://api.i18nexus.com/project_resources/translations/{{lng}}/{{ns}}.json?api_key=${apiKey}`;

// Local fallback strings for keys not yet published in the i18nexus project.
// Injected after init via addResourceBundle (deep merge, no overwrite) so the
// remote backend still loads everything normally; once a key is added to
// i18nexus the remote value wins over the fallback here.
const fallbackResources: Record<string, Record<string, Record<string, string>>> = {
  en: { default: { "u-sleep": "Sleep" } },
  es: { default: { "u-sleep": "Sueño" } },
  fr: { default: { "u-sleep": "Sommeil" } }
};

const applyFallbackResources = () => {
  Object.entries(fallbackResources).forEach(([lng, namespaces]) => {
    Object.entries(namespaces).forEach(([ns, keys]) => {
      // deep=true (merge into existing bundle), overwrite=false (never clobber remote)
      i18next.addResourceBundle(lng, ns, keys, true, false);
    });
  });
};

i18next
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",

    ns: ["default"],
    defaultNS: "default",

    supportedLngs: ["en", "es", "fr"],

    backend: {
      loadPath: loadPath
    }
  })
  .then(applyFallbackResources);

// Re-apply after any backend load so the fallback survives namespace merges
// without overwriting remote values.
i18next.on("loaded", applyFallbackResources);
